import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, HostBinding, input } from '@angular/core';
import { ArticleImageComponent } from './article-image/article-image.component';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  imports: [CommonModule, ArticleImageComponent],
})
export class Article {
  @HostBinding('class') class = 'w-full ';

  title = input<string>();
  sub = input<boolean, string>(false, { transform: booleanAttribute });
  image = input<string>();
  imageExpand = input<boolean, string>(false, { transform: booleanAttribute });
}
